<template>
  <div class="collection-item-information">
    <div class="collection-item">
      <div class="title">{{collectionItem.title}}</div>
      <div class="subtitle">
        {{collectionItem.key}}
      </div>
      <small>
        สร้างเมื่อ {{formatDateTime(collectionItem.createdAt)}}
      </small>
    </div>
  </div>
</template>

<script>
import dateFormetter from '@/utils/dateFormatter';

export default {
  mixins: [dateFormetter],
  props: {
    collectionItem: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';


.title {
  color: $gray-700;
  font-weight: bold;
}

.taxonomy {
  color: $gray-500;
  font-size: $font-size-base * 0.875;
}
</style>
